(() => {
  const button = document.querySelector('[data-apella-whatsapp]');
  if (!button) return;
  let bars = [];
  let frame;
  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      let bottom = 0;
      if (window.innerWidth < 990) {
        for (const bar of bars) {
          const style = getComputedStyle(bar);
          if (style.display === 'none') continue;
          // Visibility is still hidden on the first frame of the entrance transition.
          // The class is the sticky bar's intended state, so reserve its space now.
          if (bar.matches('.apella-sticky-atc')) {
            if (!bar.classList.contains('is-visible')) continue;
          } else if (style.visibility === 'hidden') continue;
          bottom = Math.max(bottom, bar.offsetHeight + (parseFloat(style.bottom) || 0) + 14);
        }
      }
      if (bottom > 0) button.style.setProperty('--apella-support-bottom', `${bottom}px`);
      else button.style.removeProperty('--apella-support-bottom');
    });
  };
  const resize = new ResizeObserver(update);
  const mutation = new MutationObserver(update);
  const bind = () => {
    resize.disconnect();
    mutation.disconnect();
    bars = [...document.querySelectorAll('.apella-mobile-nav, .apella-sticky-atc')];
    for (const bar of bars) {
      resize.observe(bar);
      mutation.observe(bar, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    }
    update();
  };
  window.addEventListener('resize', update, { passive: true });
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', bind);
  bind();
})();
